import { render, staticRenderFns } from "./CheckoutComponent.vue?vue&type=template&id=397c9aea"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports